// removed by extract-text-webpack-plugin
module.exports = {"row":"style-row-a21f22f3","col":"style-col-af28bfce","button":"style-button-40e73b59","bannerAd":"style-bannerAd-02334329","rail":"style-rail-bdc4a6e2","modalOverlay":"style-modalOverlay-81ebee08","modalContent":"style-modalContent-67d10a91","spinner":"style-spinner-b4055aa3","modalDialog":"style-modalDialog-5b108fc4"};


//////////////////
// WEBPACK FOOTER
// ./src/components/LoadingSpinner/style.scss
// module id = 900
// module chunks = 0